import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { FiCamera } from "react-icons/fi";
import {
  captureFrameToFile,
  startCameraStream,
  stopCameraStream,
} from "../utils/media";

// Mở camera, cho phép chụp 1 ảnh -> onCapture(File)
const CameraCapture = ({ onCapture, capturing = false }) => {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [error, setError] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const stream = await startCameraStream("environment");
        if (!active) {
          stopCameraStream(stream);
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play().catch(() => {});
          setReady(true);
        }
      } catch (e) {
        setError(e?.message || "Không mở được camera");
      }
    })();
    return () => {
      active = false;
      stopCameraStream(streamRef.current);
    };
  }, []);

  const handleCapture = async () => {
    if (!videoRef.current) return;
    try {
      const file = await captureFrameToFile(videoRef.current);
      onCapture?.(file);
    } catch (e) {
      setError(e?.message || "Không chụp được ảnh");
    }
  };

  if (error) {
    return (
      <Box bg="#FFF0F0" color="#EF2E14" p="12px" borderRadius="8px" fontSize="13px">
        {error}
      </Box>
    );
  }

  return (
    <Flex direction="column" gap="12px" align="center">
      <Box
        w="100%"
        maxW="360px"
        borderRadius="12px"
        overflow="hidden"
        bg="black"
        position="relative"
        sx={{ aspectRatio: "3 / 4" }}
      >
        <video
          ref={videoRef}
          playsInline
          muted
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
      <Button
        leftIcon={<FiCamera />}
        onClick={handleCapture}
        isDisabled={!ready || capturing}
        isLoading={capturing}
        bgImage="var(--color-button)"
        color="white"
        _hover={{ bgImage: "var(--color-button)", opacity: 0.92 }}
        w="100%"
        maxW="360px"
      >
        Chụp ảnh chấm công
      </Button>
      {!ready && (
        <Text fontSize="12px" color="var(--color-label-employee)">
          Đang khởi động camera...
        </Text>
      )}
    </Flex>
  );
};

export default CameraCapture;
